const getSubdomain = (host: string) => {
  let arr = host
    .replace(/^https?:\/\//, '')
    .replace('www.', '')
    .split('.');

  if (
    host.includes('ngrok.io') ||
    host.includes('herokuapp.com') ||
    host.includes('swiftinflow.test') || // For running local on client machine
    host.includes('fly.dev')
  ) {
    arr = arr.slice(0, -3);
    return arr[0];
  }

  if (host.includes('localhost')) {
    arr = arr.slice(0, -1);
    return arr[0];
  }

  arr = arr.slice(0, -2);

  return arr[0];
};

export default getSubdomain;
